module.exports = __webpack_public_path__ + "img/diagram_7_1.8ee9a47e.png";